import React, { useEffect, useState, useRef } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Skeleton } from 'primereact/skeleton';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';

import TableTopTitle from 'components/TableTopTitle';

import fetchApi from 'lib/fetchApi';
import functions from 'lib/functions';

const AppConfig = (props) => {
  const toast = useRef(null);
  const [configs, setConfigs] = useState(null);
  const [configPromotion, setConfigPromotion] = useState(null);
  const [isLoadingConfigs, setIsLoadingConfigs] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    props.setPageParams({
      alias: 'appconfig',
      title: 'App 設置'
    });
    getAppConfigs();
  }, []);

  const getAppConfigs = async () => {
    setIsLoadingConfigs(true);
    const responseConfigs = await fetchApi('appconfig/list');
    setConfigs(responseConfigs.data.configs.map((config) => {
      if (config.field === 'promotion') {
        setConfigPromotion(JSON.parse(config.value));
      }
      return {
        field: config.field,
        field_name: config.field_name,
        value: config.value
      };
    }));
    setIsLoadingConfigs(false);
  };

  const updateConfigs = (field, value) => {
    setConfigs(configs.map((config) => {
      if (config.field === field) {
        return {
          ...config,
          value: value
        };
      } else {
        return config;
      }
    }))
  };

  const updatePromotionConfigs = async (field, value) => {
    var tmpConfigPromotion = {...configPromotion};
    switch (field) {
      default:
        tmpConfigPromotion[field] = value;
        break;
      case 'name.zh':
        tmpConfigPromotion.name.zh = value;
        break;
      case 'name.en':
        tmpConfigPromotion.name.en = value;
        break;
      case 'description.zh':
        tmpConfigPromotion.description.zh = value;
        break;
      case 'description.en':
        tmpConfigPromotion.description.en = value;
        break;
    }
    setConfigPromotion(tmpConfigPromotion);
    updateConfigs('promotion', tmpConfigPromotion);
  };

  const saveConfigs = async (field) => {
    var config = configs.filter(config => config.field === field)[0];
    // validation
    if (config.field === 'token_expiry_days') {
      if (!functions.validateValue('numeric', config.value)) {
        toast.current.show({ severity: 'error', summary: 'App 設置', detail: `「${config.field_name}」設置錯誤` });
        return false;
      }
    }
    if (config.field === 'token_unlock_helper') {
      if (!functions.validateValue('numeric', config.value)) {
        toast.current.show({ severity: 'error', summary: 'App 設置', detail: `「${config.field_name}」設置錯誤` });
        return false;
      }
    }
    if (config.field === 'promotion') {
      if (!functions.validateValue('numeric', configPromotion.days)) {
        toast.current.show({ severity: 'error', summary: 'App 設置', detail: `「優惠碼」的「訂閱日數」設置錯誤` });
        return false;
      }
      if (configPromotion.days <= 0) {
        toast.current.show({ severity: 'error', summary: 'App 設置', detail: `「優惠碼」的「訂閱日數」設置錯誤` });
        return false;
      }
      if (configPromotion.code.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'App 設置', detail: `「優惠碼」不可為空` });
        return false;
      }
      if (configPromotion.name.en.trim() === '' || configPromotion.name.zh.trim() === '' || configPromotion.description.en.trim() === '' || configPromotion.description.zh.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'App 設置', detail: `「優惠碼」的名稱及簡介不可為空` });
        return false;
      }
    }
    // save
    setIsSaving(true);
    const responseSaveConfigs = await fetchApi('appconfig/save', {
      field: config.field,
      value: config.value
    });
    toast.current.show({ severity: 'success', summary: 'App 設置', detail: `已成功儲存 App 設置（${config.field_name}）` });
    setIsSaving(false);
  };

  return (
    <>
      <div className="mb-2">
        <Toolbar
          className="flex-column lg:flex-row p-0 border-0 bg-white align-items-start"
          start={<TableTopTitle title="App 設置" subTitle="這裡可以進行各項 App 設置。" />}
        />
      </div>
      {configs === null ?
        <>
          <Skeleton className="mb-1 w-full h-4rem"></Skeleton>
          <Skeleton className="mb-1 w-full h-4rem"></Skeleton>
          <Skeleton className="mb-1 w-full h-4rem"></Skeleton>
          <Skeleton className="mb-1 w-full h-4rem"></Skeleton>
          <Skeleton className="mb-1 w-full h-4rem"></Skeleton>
          <Skeleton className="mb-1 w-full h-4rem"></Skeleton>
          <Skeleton className="mb-1 w-full h-4rem"></Skeleton>
        </>
        :
        <>
          <Accordion multiple activeIndex={null}>
            <AccordionTab header="職業介紹所牌照號碼">
              <div className="flex flex-column">
                <div className="col col-12 lg:col-6">
                  <div className="flex flex-column gap-2">
                    <label>牌照號碼</label>
                    <InputText value={configs.filter(config => config.field === 'license')[0]?.value} onChange={(e) => {updateConfigs('license', e.target.value)}} disabled={isSaving} />
                    <small>牌照號碼顯示於手機 App 的首頁底部。</small>
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('license')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="WhatsApp 連結">
              <div className="flex flex-column">
                <div className="col col-12 lg:col-6">
                  <div className="flex flex-column gap-2">
                    <label>WhatsApp 連結</label>
                    <InputText value={configs.filter(config => config.field === 'whatsapp_link')[0]?.value} onChange={(e) => {updateConfigs('whatsapp_link', e.target.value)}} disabled={isSaving} placeholder="https://api.whatsapp.com/send?phone=85290000000&text=Hello" />
                    <small>這是使用者在按下「WhatsApp 聯絡我們」按鈕時所跳至的網頁。</small>
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('whatsapp_link')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="首頁 YouTube 影片">
              <div className="flex flex-column">
                <div className="col p-0 flex flex-row">
                  <div className="col col-12 lg:col-6">
                    <div className="flex flex-column gap-2">
                      <label>首頁 YouTube 影片</label>
                      <InputText value={configs.filter(config => config.field === 'home_youtube_link')[0]?.value} onChange={(e) => {updateConfigs('home_youtube_link', e.target.value)}} disabled={isSaving} placeholder="OMOyBhSwiI0" />
                      <small>請輸入 YouTube 影片代碼（例如 https://www.youtube.com/watch?v=OMOyBhSwiI0，請輸入影片代碼：OMOyBhSwiI0）</small>
                    </div>
                  </div>
                  <div className="col col-12 lg:col-6">
                    <iframe width="180" height="100" src={`https://www.youtube.com/embed/${configs.filter(config => config.field === 'home_youtube_link')[0]?.value}?&autoplay=0`} frameborder="0" allowfullscreen className="border-round"></iframe>
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('home_youtube_link')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="購買點數（Token）有效日數">
              <div className="flex flex-column">
                <div className="col col-12 lg:col-6">
                  <div className="flex flex-column gap-2">
                    <label>購買點數（Token）有效日數</label>
                    <InputNumber value={configs.filter(config => config.field === 'token_expiry_days')[0]?.value} onChange={(e) => {updateConfigs('token_expiry_days', e.value)}} disabled={isSaving} placeholder="30" />
                    <small>設定用戶所購買點數的有效日數或延長有效日數（由購買當天起計）。</small>
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('token_expiry_days')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="解鎖姐姐所需點數">
              <div className="flex flex-column">
                <div className="col col-12 lg:col-6">
                  <div className="flex flex-column gap-2">
                    <label>解鎖姐姐所需點數</label>
                    <InputNumber value={configs.filter(config => config.field === 'token_unlock_helper')[0]?.value} onChange={(e) => {updateConfigs('token_unlock_helper', e.value)}} disabled={isSaving} placeholder="1" />
                    <small>設定用戶解鎖姐姐的聯絡資訊所需要消費的點數。</small>
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('token_unlock_helper')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="WhatsApp 姐姐的預設訊息">
              <div className="flex flex-column">
                <div className="col col-12 lg:col-6">
                  <div className="flex flex-column gap-2">
                    <label>WhatsApp 姐姐的預設訊息</label>
                    <InputText value={configs.filter(config => config.field === 'whatsapp_helper_default_message')[0]?.value} onChange={(e) => {updateConfigs('whatsapp_helper_default_message', e.target.value)}} disabled={isSaving} placeholder="Hi $helpername, I found your profile on the Helper Station App and am interested in discussing your services. Are you available to chat? Thanks!" />
                    <small>使用 <code>$helpername</code> 以代表外傭姓名。（例子：Hi $helpername, I found your profile on the Helper Station App and am interested in discussing your services. Are you available to chat? Thanks!）</small>
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('whatsapp_helper_default_message')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header="聘請外傭的 WhatsApp 預設訊息">
              <div className="flex flex-column">
                <div className="col col-12 lg:col-6">
                  <div className="flex flex-column gap-2">
                    <label>聘請外傭的 WhatsApp 預設訊息</label>
                    <InputText value={configs.filter(config => config.field === 'whatsapp_hire_default_message')[0]?.value} onChange={(e) => {updateConfigs('whatsapp_hire_default_message', e.target.value)}} disabled={isSaving} placeholder="Hi $helpername, I found your profile on the Helper Station App and am interested in discussing your services. Are you available to chat? Thanks!" />
                    <small>使用 <code>$helpername</code> 代表外傭姓名、<code>$employername</code> 代表僱主姓名、使用 <code>$helpernumber</code> 代表外傭編號（例子：Hi 我係申請人 $employername，想申請招聘外傭 $helpername，編號 $helpernumber）</small>
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('whatsapp_hire_default_message')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
            <AccordionTab header={<>優惠碼 {configPromotion.enabled?`🟢`:``}</>}>
              <div className="flex flex-column">
                <div className="flex flex-row">
                  <div className="col col-12 lg:col-2">
                    <div className="flex flex-column gap-2">
                      <label>優惠名稱（中文）</label>
                      <InputText value={configPromotion.name.zh} onChange={(e) => {updatePromotionConfigs('name.zh', e.target.value)}} disabled={isSaving} placeholder="限時免費訂閱" />
                    </div>
                  </div>
                  <div className="col col-12 lg:col-4">
                    <div className="flex flex-column gap-2">
                      <label>優惠名稱（英文）</label>
                      <InputText value={configPromotion.name.en} onChange={(e) => {updatePromotionConfigs('name.en', e.target.value)}} disabled={isSaving} placeholder="Limited-Time Free Subscription" />
                    </div>
                  </div>
                </div>
                <div className="flex flex-row">
                  <div className="col col-12 lg:col-2">
                    <div className="flex flex-column gap-2">
                      <label>優惠簡介（中文）</label>
                      <InputTextarea rows="4" autoResize value={configPromotion.description.zh} onChange={(e) => {updatePromotionConfigs('description.zh', e.target.value)}} disabled={isSaving} placeholder="輸入優惠碼取得30天限時免費訂閱優惠！" />
                    </div>
                  </div>
                  <div className="col col-12 lg:col-4">
                    <div className="flex flex-column gap-2">
                      <label>優惠簡介（英文）</label>
                      <InputTextarea rows="4" autoResize value={configPromotion.description.en} onChange={(e) => {updatePromotionConfigs('description.en', e.target.value)}} disabled={isSaving} placeholder="Enter the promo code to get a 30-day limited-time free subscription offer!" />
                    </div>
                  </div>
                </div>
                <div className="flex flex-row">
                  <div className="col col-12 lg:col-2">
                    <div className="flex flex-column gap-2">
                      <label>優惠碼</label>
                      <InputText value={configPromotion.code} onChange={(e) => {updatePromotionConfigs('code', e.target.value)}} disabled={isSaving} placeholder="LOVE30DAYS" />
                    </div>
                  </div>
                  <div className="col col-12 lg:col-2">
                    <div className="flex flex-column gap-2">
                      <label>訂閱日數</label>
                      <InputNumber value={configPromotion.days} onChange={(e) => {updatePromotionConfigs('days', e.value)}} disabled={isSaving} placeholder="30" />
                    </div>
                  </div>
                  <div className="col col-12 lg:col-2">
                    <div className="flex flex-column gap-2">
                      <label>啟用</label>
                      <InputSwitch checked={configPromotion.enabled} onChange={(e) => updatePromotionConfigs('enabled', e.value)} />
                    </div>
                  </div>
                  <div className="col col-12 lg:col-2">
                  </div>
                </div>
                <div className="col col-12 flex justify-content-start align-items-end">
                  <Button label="儲存" size="small" onClick={() => {saveConfigs('promotion')}} disabled={isLoadingConfigs || isSaving} />
                </div>
              </div>
            </AccordionTab>
          </Accordion>
        </>
      }
      <Toast ref={toast} position="top-center" />
    </>
  );
};

export default AppConfig;